export default __webpack_public_path__ + "static/media/fanSilverImage.f1a4dd75.png";